module.exports = __webpack_public_path__ + "images/ed16e59.png";